import { h, Component } from 'preact';
import airportStyle from 'components/bolt/airport/airport.sss';
import Store from 'store/store';


export default class Clock extends Component {
	constructor(props) {
		super(props);
		this.setTime = this.setTime.bind(this);
		this.state = {
			currentTime: '12:00',
			amOrPm: 'PM'
		};
	}

	componentDidMount() {
		this.setTime();
	}

	componentWillUnmount() {
		window.clearTimeout(this.clock);
	}

	setTime() {
		let hours = new Date().getHours();
		let minutes = new Date().getMinutes();
		const icon = (hours >= 7 && hours < 19) ? 'sun' : 'moon';
		Store.emit('SET_WEATHER_ICON', icon );

		const amOrPm = hours >= 12 ? 'PM' : 'AM';

		if (hours === 0) {
			hours = 12;
		} else if (hours > 12) {
			hours = hours % 12;
		}

		if (hours < 10) {
			hours = `0${hours}`;
		}

		if (minutes < 10) {
			minutes = `0${minutes}`;
		}

		this.setState({
			currentTime: `${hours}:${minutes}`,
			amOrPm
		});
		this.clock = window.setTimeout(this.setTime, 1000);
	}


	render({ imageRoot }) {
		const { currentTime, amOrPm } = this.state;
		return (
			<div class={airportStyle.timeContainer}>
				<img class={airportStyle.timeContainerImage} src={`${imageRoot}/airport/header/wfhll2.webp`} />
				<span class={airportStyle.time}>{currentTime}</span>
				<span class={airportStyle.amPm}>{amOrPm}</span>
				<div class={airportStyle.headerLines} />
				<div class={airportStyle.timeShine} />
			</div>
		);
	}
}